import io from 'socket.io-client'
import {checkBuild} from '../../src/utils/newVersion.js'

const options = {
    transports: ['websocket']
}

const socket = io(options)

connect()

// Reloading on a stop or the scan page would throw away the photos, signature or scans the courier is entering
const busyPaths = /^\/koerier\/(ophalen|bezorgen|bundel|scan)(\/|$)/

socket.on('joined', () => {
    console.log('connected')
})

socket.on('build', (builds) => checkBuild('messenger', builds, {canReload: () => !busyPaths.test(window.location.pathname)}))

socket.on('disconnect', () => {
    console.log('disconnected')
    connect()
})

function connect() {
    if (localStorage.mtoken) {
        console.log('connecting...')
        socket.emit('join', localStorage.mtoken)
    }
}

export default socket
